// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-table {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
}

.skeleton-header,
.skeleton-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.skeleton-line {
  height: 16px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  background-color: #e0e0e0;
}

/* اضافه کردن لایه انیمیشن shimmer */
.skeleton-line::after {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(300%);
  }
}

/* کلاس های عرض */
.w-25 { width: 25%; }
.w-16 { width: 16.6667%; }

`, "",{"version":3,"sources":["webpack://./src/components/SkeletonLoader/SkeletonLoader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ;;;;;GAKC;EACD,gCAAgC;AAClC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,iBAAiB;AACjB,QAAQ,UAAU,EAAE;AACpB,QAAQ,eAAe,EAAE","sourcesContent":[".skeleton-table {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 12px;\n}\n\n.skeleton-header,\n.skeleton-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.skeleton-line {\n  height: 16px;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n  background-color: #e0e0e0;\n}\n\n/* اضافه کردن لایه انیمیشن shimmer */\n.skeleton-line::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -150%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.6) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(300%);\n  }\n}\n\n/* کلاس های عرض */\n.w-25 { width: 25%; }\n.w-16 { width: 16.6667%; }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
